/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Restore_KeepInputs */



/**
* | output |
* | --- |
* | "Leave cancelled" |
*
* @param {Rounds_Restore_KeepInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_restore_keep = /** @type {((inputs?: Rounds_Restore_KeepInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Restore_KeepInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Laisser annulée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dejar cancelada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Manter cancelada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lascia annullato")
	return /** @type {LocalizedString} */ ("Leave cancelled")
});